/**
* @prop --cbp-notice-color-text: var(--cbp-color-text-darkest);
* @prop --cbp-notice-color-text-dark: var(--cbp-color-text-lightest);
* @prop --cbp-notice-color-title: var(--cbp-color-text-darker);
* @prop --cbp-notice-color-title-dark: var(--cbp-color-text-lighter);
* @prop --cbp-notice-color-background: var(--cbp-color-info-lighter);
* @prop --cbp-notice-color-background-dark: var(--cbp-color-info-dark);
* @prop --cbp-notice-color-border: var(--cbp-color-info-base);
* @prop --cbp-notice-color-border-dark: var(--cbp-color-info-light);
*/

:root {
  --cbp-notice-color-text: var(--cbp-color-text-darkest);
  --cbp-notice-color-text-dark: var(--cbp-color-text-lightest);
  --cbp-notice-color-title: var(--cbp-color-text-darker);
  --cbp-notice-color-title-dark: var(--cbp-color-text-lighter);
  --cbp-notice-color-background: var(--cbp-color-info-lighter);
  --cbp-notice-color-background-dark: var(--cbp-color-info-dark);
  --cbp-notice-color-border: var(--cbp-color-info-base);
  --cbp-notice-color-border-dark: var(--cbp-color-info-light);
}

[data-cbp-theme=light] cbp-notice[context*=dark]:not([context=light-always]),
[data-cbp-theme=dark] cbp-notice:not([context=dark-inverts]):not([context=light-always]) {
  --cbp-notice-color-text: var(--cbp-notice-color-text-dark) !important;
  --cbp-notice-color-title: var(--cbp-notice-color-title-dark) !important;
  --cbp-notice-color-background: var(--cbp-notice-color-background-dark) !important;
  --cbp-notice-color-border: var(--cbp-notice-color-border-dark) !important;
}

cbp-notice {
  display: block;
  background-color: var(--cbp-notice-color-background);
  border: var(--cbp-border-size-md) solid var(--cbp-notice-color-border);
  // border-left: var(--cbp-space-2x) solid var(--cbp-notice-color-border);
  border-left-width: var(--cbp-space-2x);
  border-radius: var(--cbp-border-radius-softer);
  color: var(--cbp-notice-color-text);
  padding: var(--cbp-space-3x);

  [slot=cbp-notice-title] {
    --cbp-icon-size: var(--cbp-space-5x);
    display: inline-block;
    margin-block-end: var(--cbp-space-2x);

    * {
      font-weight: var(--cbp-font-weight-bold);
      color: var(--cbp-notice-color-title);
      margin-bottom: 0;
    }
  }

  &[color=success] {
    --cbp-notice-color-background: var(--cbp-color-success-lighter);
    --cbp-notice-color-background-dark: var(--cbp-color-success-dark);

    --cbp-notice-color-border: var(--cbp-color-success-base);
    --cbp-notice-color-border-dark: var(--cbp-color-success-light);
  }

  &[color=warning] {
    --cbp-notice-color-background: var(--cbp-color-warning-lighter);
    --cbp-notice-color-background-dark: var(--cbp-color-warning-darker);

    --cbp-notice-color-border: var(--cbp-color-warning-base);
    --cbp-notice-color-border-dark: var(--cbp-color-warning-base);
  }

  &[color=danger] {
    --cbp-notice-color-background: var(--cbp-color-danger-lighter);
    --cbp-notice-color-background-dark: var(--cbp-color-danger-dark);

    --cbp-notice-color-border: var(--cbp-color-danger-base);
    --cbp-notice-color-border-dark: var(--cbp-color-danger-light);
  }
}
